import React from "react";
import { CountdownTimer } from "../common";
import { getEventStatusText } from "../../../utils/newyear/eventDateUtils";
import { getLotteryUserStatusText } from "../../../utils/newyear/formatters";

const LotteryStatus = ({ status, userStatus }) => {
  if (!status) return null;

  const {
    eventStatus,
    totalSlots,
    subscriberCount,
    openTime,
    closeTime,
    drawTime,
  } = status;

  const isOpen = eventStatus === "OPEN";
  const isScheduled = eventStatus === "SCHEDULED";
  const isDrawn = eventStatus === "DRAWN";

  return (
    <div className="newyear-lottery-status">
      <div className="newyear-lottery-status__header">
        <h3 className="newyear-lottery-status__title">추첨 이벤트</h3>
        <span className={`newyear-lottery-status__badge newyear-lottery-status__badge--${eventStatus.toLowerCase()}`}>
          {getEventStatusText(eventStatus)}
        </span>
      </div>

      <div className="newyear-lottery-status__info">
        <div className="newyear-lottery-status__stat">
          <span className="newyear-lottery-status__stat-label">총 당첨 인원</span>
          <span className="newyear-lottery-status__stat-value">{totalSlots}명</span>
        </div>

        <div className="newyear-lottery-status__stat">
          <span className="newyear-lottery-status__stat-label">현재 청약자</span>
          <span className="newyear-lottery-status__stat-value">{subscriberCount}명</span>
        </div>

        {userStatus && (
          <div className="newyear-lottery-status__user-status">
            <span className="newyear-lottery-status__user-label">나의 상태</span>
            <span className={`newyear-lottery-status__user-value newyear-lottery-status__user-value--${userStatus.toLowerCase()}`}>
              {getLotteryUserStatusText(userStatus)}
            </span>
          </div>
        )}
      </div>

      <div className="newyear-lottery-status__schedule">
        {isScheduled && openTime && (
          <CountdownTimer
            deadline={openTime}
            label="청약 시작까지"
          />
        )}

        {isOpen && closeTime && (
          <CountdownTimer
            deadline={closeTime}
            label="청약 마감까지"
          />
        )}

        {!isDrawn && drawTime && (
          <div className="newyear-lottery-status__draw-time">
            <span className="newyear-lottery-status__draw-label">추첨 예정</span>
            <span className="newyear-lottery-status__draw-value">
              {new Date(drawTime).toLocaleString("ko-KR")}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default LotteryStatus;
